<template>
  <div id="header">
    <img src="/images/logo_white.avif" @click="$router.push('/')" />
    <div class="text-container">
      <h1>Decision Workflow</h1>
      <h6>Powered by MIC</h6>
    </div>
    <v-btn @click="$router.push('/tools')">All tools</v-btn>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
#header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  padding: 10px;
  background-color: var(--primaryColor);
  border-bottom: 5px solid var(--primaryColorDark);
}

.text-container {
  text-align: left;
  margin-left: 10px;
}

h1,
h6 {
  color: var(--colorOnPrimary);
}

img {
  height: 70px;
  cursor: pointer;
}
</style>
